import styled from "styled-components";


export const ContactContainer=styled.div`
width:100%;
height:100vh;

display:flex;
justify-content:center;
align-items:center;

@media only screen and (max-width:900px){
    padding-bottom:10vh;
}
@media only screen and (max-width:700px){
    padding-bottom:10vh;
    padding-top:20px;
}
`;

export const InnerContainer=styled.div`
position:relative;
width:55%;
background:linear-gradient(to bottom right,#00e0ff ,#00b7ff,#004fff );
border-radius:16px;
color:white;
display:flex;
align-items:start;
justify-content:space-around;

img{
    position:absolute;
left:-27%;
height:75vh;

}

@media only screen and (max-width: 900px) {
    width:80%;
    flex-direction:column;
    align-items:center;
    padding-bottom:10px;
    img{
       display:none;
    }
}
@media only screen and (max-width: 700px) {
    width:90%;

}
`;

export const Left=styled.div`
width:40%;

div{
    height:fit-content;
    margin-top:100px;
   
    h5{
        display:flex;
        gap:10px;
        align-items:center;
        font-size:14px;
    }
    span{
        font-size:18px;
    }
}
@media only screen and (max-width: 900px) {
    width:90%;
    div{
        margin-top:0px;
    }
`;

export const Right=styled.div`
width:50%;

form{
    height:80%;
    height:53vh;
    display:flex;
    flex-direction:column;
    justify-content:space-around;
    gap:10px;

    input, textarea{
        width:95%;
        height:30px;
        border-radius:8px;
        border:none;
        background:rgba(250, 249, 246,.8);

    }

    textarea{
        height:120px;       
    }

    button{
        width:150px;
        height:30px;
        border-radius:8px;
        border:none;
        background-image: linear-gradient(to bottom right, #004fff , #0ff );
        color:white;
        font-weight:700;
    }
}
@media only screen and (max-width: 900px) {
    width:90%;
    form{
        align-items:center;
    }
}
`;


export const Popup = styled.div`
position:fixed;
z-index:10;
top:50%;
left:50%;
padding:0 10px;
border-radius:8px;
transform: translate(-50%, -50%);

${props=> props.color && `
background: ${props.color};
`}

`